import { environment } from 'src/environments/environment';

const normalizeBaseUrl = (url: string | undefined): string =>
  `${url || ''}`.trim().replace(/\/+$/, '');

export const SCENE_GROUP_API_BASE = `${normalizeBaseUrl(environment.endpoints.webBackend)}/admin`;

export const SCENE_GROUP_API_HOST = (() => {
  try {
    return new URL(normalizeBaseUrl(environment.endpoints.webBackend)).host;
  } catch {
    return '';
  }
})();

// True only for requests to the /admin subtree of the web backend. Matching the host
// alone would also capture the many user-facing calls to the same host (home feed, likes,
// collections, sharing…) and wrongly attach the admin's Bearer token + withCredentials to
// them. Gate on the /admin path prefix as well.
export const isSceneGroupApiUrl = (url: string): boolean => {
  let base: URL;
  try {
    base = new URL(SCENE_GROUP_API_BASE);
  } catch {
    return false;
  }

  try {
    const target = new URL(url);
    return (
      target.host === base.host &&
      (target.pathname === base.pathname || target.pathname.startsWith(`${base.pathname}/`))
    );
  } catch {
    // Unparseable URL (relative, or protocol-relative like `//host/path`). Never fall back
    // to a substring test: `//web-main-back.3dway.io.attacker.example/admin` would match it
    // and the interceptor would hand the admin's Firebase token to the attacker's host.
    return false;
  }
};
